import Component from "grimoirejs/ref/Node/Component";
export default class ParagraphComponent extends Component {
    $slideStart() {
        console.log("slideStart");
    }
    $slideEnd() {
        console.log("slideEnd");
    }
}
ParagraphComponent.attributes = {
    parent: {
        default: "div#paragraph-root",
        converter: "String"
    }
};



// WEBPACK FOOTER //
// ./src/Components/ParagraphComponent.ts